export const questionStemRegex = /\[question-stem\]([\s\S]*?)\[\/question-stem\]/;

export function stripQuestionStem(text: string): string {
  return text.replace(questionStemRegex, '');
}

export function extractQuestionStem(text: string): string {
  return text.match(questionStemRegex)?.[1] ?? '';
}
